export const MICRONUTRIENT_FIELDS = Object.freeze([
  { key: "water", labelKey: "water-string", unit: "g" },
  { key: "sodium", labelKey: "sodium-string", unit: "mg" },
  { key: "potassium", labelKey: "potassium-string", unit: "mg" },
  { key: "magnesium", labelKey: "magnesium-string", unit: "mg" },
  { key: "iron", labelKey: "iron-string", unit: "mg" },
  { key: "calcium", labelKey: "calcium-string", unit: "mg" },
  { key: "vitaminD", labelKey: "vitaminD-string", unit: "mcg" },
  { key: "leucine", labelKey: "leucine-string", unit: "g" },
  { key: "omega3", labelKey: "omega3-string", unit: "g" },
  { key: "caffeine", labelKey: "caffeine-string", unit: "mg" },
  { key: "sugars", labelKey: "sugars-string", unit: "g" },
  { key: "saturatedFat", labelKey: "saturatedFat-string", unit: "g" },
  {
    key: "monounsaturatedFat",
    labelKey: "monounsaturatedFat-string",
    unit: "g",
  },
  {
    key: "polyunsaturatedFat",
    labelKey: "polyunsaturatedFat-string",
    unit: "g",
  },
  { key: "transFat", labelKey: "transFat-string", unit: "g" },
  { key: "cholesterol", labelKey: "cholesterol-string", unit: "mg" },
  { key: "alcohol", labelKey: "alcohol-string", unit: "g" },
  { key: "vitaminB12", labelKey: "vitaminB12-string", unit: "mcg" },
  { key: "vitaminB9", labelKey: "vitaminB9-string", unit: "mcg" },
  { key: "iodine", labelKey: "iodine-string", unit: "mcg" },
  { key: "zinc", labelKey: "zinc-string", unit: "mg" },
  { key: "selenium", labelKey: "selenium-string", unit: "mcg" },
  { key: "phosphorus", labelKey: "phosphorus-string", unit: "mg" },
  { key: "vitaminC", labelKey: "vitaminC-string", unit: "mg" },
  { key: "vitaminA", labelKey: "vitaminA-string", unit: "mcg" },
  { key: "vitaminB6", labelKey: "vitaminB6-string", unit: "mg" },
  { key: "vitaminB1", labelKey: "vitaminB1-string", unit: "mg" },
  { key: "vitaminB2", labelKey: "vitaminB2-string", unit: "mg" },
  { key: "vitaminB3", labelKey: "vitaminB3-string", unit: "mg" },
  { key: "vitaminB5", labelKey: "vitaminB5-string", unit: "mg" },
  { key: "vitaminB7", labelKey: "vitaminB7-string", unit: "mcg" },
  { key: "vitaminE", labelKey: "vitaminE-string", unit: "mg" },
  { key: "vitaminK", labelKey: "vitaminK-string", unit: "mcg" },
  { key: "copper", labelKey: "copper-string", unit: "mg" },
  { key: "manganese", labelKey: "manganese-string", unit: "mg" },
]);

export const MICRONUTRIENT_KEYS = Object.freeze(
  MICRONUTRIENT_FIELDS.map((field) => field.key),
);

export function createEmptyMicronutrients(initialValue = 0) {
  return MICRONUTRIENT_KEYS.reduce((accumulator, key) => {
    accumulator[key] = initialValue;
    return accumulator;
  }, {});
}
